import { gozokiApiWithAuth } from '../gozokiApi'

export const deleteAdmin = async (adminId: number) => {
  const response = await gozokiApiWithAuth.delete(`/admins/${adminId}`)
  return response.data
}
